export default "__VITE_ASSET__tUJyLVpQ__"